import React from 'react'
import { FilterComponent, FilterExtraAction } from '../../components/_WMS/FilterComponent/FilterComponent'
import { filterOptions } from './config'
import { Filter } from '../../components/_WMS/FilterComponent'

export interface FilterOption {
  order: number
  key: string
  label: string
  type: 'numeric' | 'text' | 'range' | 'precreated' | 'custom' | 'date'
  options?: []
  Component?: React.ComponentType<ComponentProps> // Solo para 'custom'
  // Otras propiedades que puedas necesitar para tipos específicos
}

interface ComponentProps {}
interface PreSaleSkuSearchProps {
  onSearchClick: (filters: Filter[]) => void
  selectedFilters: Filter[]
  setSelectedFilters: any
  includeAddButton?: boolean
  extraActions?: FilterExtraAction[]
}

export const PreSaleSkuSearch: React.FC<PreSaleSkuSearchProps> = (props) => {
  return <FilterComponent options={filterOptions} {...props} extraActions={props.extraActions} />
}
